import Nav from '../Components/Nav.js';
import '../styles/Header.scss';
import { ReactComponent as Logo } from '../svg/logo.svg';

const Header = $ =>
    <header>
        <Nav id="pages" {... $}/>
        <h1>
            <Logo id="logo"/>
        </h1>
        <div id="stripes"/>
    </header>

export default Header;